import { useMediaQuery } from "react-responsive";

const useDeviceDimensions = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  return { isMobile, isPortrait };
};

export default useDeviceDimensions;
